import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialUrl = "v1/data/upload/penangguhan/pembayaran";

export const getById = createAsyncThunk("penangguhanPembayaran/getById",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `${initialUrl}/${val}`
			const response = await jwtAuthAxios.get(url)
			return response.data;
		} catch(response){
			throw response
		}
	});

export const getByIdMahasiswa = createAsyncThunk("penangguhanPembayaran/getByIdMahasiswa",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `${initialUrl}/mhs/${val}`
			const response = await jwtAuthAxios.get(url)
			return response.data;
		} catch(response){
			throw response
		}
	});

export const save = createAsyncThunk("penangguhanPembayaran/save",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `${initialUrl}`
			const response = await jwtAuthAxios.post(url,val)
			return response.data;
		} catch(response){
			throw response
		}
	});


export const update = createAsyncThunk("penangguhanPembayaran/update",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `${initialUrl}`
			const response = await jwtAuthAxios.put(url,val);
			return response.data;
		} catch(response){
			throw response
		}
	});

export const remove = createAsyncThunk("penangguhanPembayaran/remove",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `${initialUrl}/${val}`
			const response = await jwtAuthAxios.delete(url);
			return response.data;
		} catch(response){
			throw response
		}
	});

const initialState = {
	loading: false,
	data: {},
	dataDosen : {},
	dataList: [],
}

const penangguhanPembayaranSlice = createSlice({
	name:"penangguhanPembayaran",
	initialState: initialState,
	extraReducers: (builder) => {
		builder
			.addCase(getByIdMahasiswa.pending, (state) => {
				state.loading = true;
			})
			.addCase(getByIdMahasiswa.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(getByIdMahasiswa.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(getById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getById.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(getById.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(save.pending, (state) => {
				state.loading = true;
			})
			.addCase(save.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(save.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(update.pending, (state) => {
				state.loading = true;
			})
			.addCase(update.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(update.rejected, (state, action) => {
				state.loading = false;
			})
		
		builder
			.addCase(remove.pending, (state) => {
				state.loading = true;
			})
			.addCase(remove.fulfilled, (state, action) => {
				state.data = action.payload;
				state.loading = false;
			})
			.addCase(remove.rejected, (state, action) => {
				state.loading = false;
			})
	}
})
export const penangguhanPembayaranSelector = (state) => state.penangguhanPembayaran;
export default penangguhanPembayaranSlice.reducer;
